import { render } from "./subscribe-page.vue?vue&type=template&id=54357d20"
import script from "./subscribe-page.vue?vue&type=script&lang=js"
export * from "./subscribe-page.vue?vue&type=script&lang=js"

import "./subscribe-page.vue?vue&type=style&index=0&id=54357d20&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__